import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaPlane, FaHotel, FaBinoculars, FaCar, FaUtensils, FaPassport, FaStar } from "react-icons/fa";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faDiamond, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FaAngleDown, FaShip } from 'react-icons/fa6';
import { GroupTourPackageDetails } from '../data/Destination';
import { useLocation, useParams } from "react-router-dom";
import Breadcrumb from '../components/Breadcrumb';
import deafultImage from "../assets/tour-package.jpg"
import HelmetComponent from '../components/Helmet';

const GroupTourPackagesDetails = () => {
    const { slug } = useParams();
    const pkg = GroupTourPackageDetails?.find(p => p?.slug === slug);
    const PackagesDetailsSection = useRef(null);
    const location = useLocation()
    useEffect(() => {
        if (location.state?.scrollTo === "details") {
            PackagesDetailsSection.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [location]);
    const [active, setActive] = useState("flights");
    const tabs = [{ id: "flights", label: "Flights", icon: <FaPlane /> }, { id: "hotels", label: "Hotels", icon: <FaHotel /> }, { id: "sightseeing", label: "Sightseeing", icon: <FaBinoculars /> }, { id: "transfers", label: "Transfers", icon: <FaCar /> }, { id: "meals", label: "Meals", icon: <FaUtensils /> }, { id: "visa", label: "Visa", icon: <FaPassport /> }, { id: "cruise", label: "Cruise", icon: <FaShip /> },];
    const filteredTabs = tabs.filter((tab) => {
        const dataMap = {
            flights: pkg?.flights,
            hotels: pkg?.hotels,
            sightseeing: pkg?.sightseeing,
            transfers: pkg?.transfers,
            meals: pkg?.meals,
            visa: pkg?.visa,
            cruise: pkg?.cruise,
        };

        return Array.isArray(dataMap[tab.id]) && dataMap[tab.id].length > 0;
    });
    const [activeIndexes, setActiveIndexes] = useState([0]);
    const toggleAccordion = (index) => {
        // agar already single open hai aur wahi click hua → close all
        if (activeIndexes.length === 1 && activeIndexes.includes(index)) {
            setActiveIndexes([]);
        } else {
            // hamesha sirf ek hi open rakho
            setActiveIndexes([index]);
        }
    };
    const toggleAll = () => {
        if (activeIndexes.length === pkg.itinerary.length) {
            setActiveIndexes([]); // collapse all
        } else {
            setActiveIndexes(pkg.itinerary.map((_, i) => i)); // expand all
        }
    };
    useEffect(() => {
        if (filteredTabs.length > 0 && !filteredTabs.find(t => t.id === active)) {
            setActive(filteredTabs[0].id);
        }
    }, [filteredTabs, active]);
    const formatSlug = (str) => {
        return str
            ?.replace(/-/g, " ")
            ?.split(" ")
            ?.map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            )
            ?.join(" ");
    };

    const formattedDestination =
        formatSlug(pkg?.destination || "");

    const seoTitle =
        `${pkg?.title || "Group Tour"} | ${pkg?.duration || ""} | ${formattedDestination} Group Tour Package`;

    const seoDescription =
        `${pkg?.title || ""} group tour package for ${formattedDestination}. Includes hotels, sightseeing, transfers, meals, flights and customized travel services with Shri Radhe Holidays.`;

    const seoImage =
        pkg?.images?.[0] ||
        pkg?.image ||
        "https://www.shriradheholidays.com/logo2.png";

    const seoUrl =
        `https://www.shriradheholidays.com${location.pathname}`;
    return (
        <>
            <HelmetComponent
                title={seoTitle}
                description={seoDescription}
                image={seoImage}
                url={seoUrl}
            />
            {pkg ?
                (
                    <>
                        <div className="max-md:px-4 md:px-4 lg:px-4 xl:px-4 py-4   bg-[#0B1C3D] " id="details" ref={PackagesDetailsSection}>
                            <Breadcrumb title={pkg?.title || "Itinerary"} destination={pkg?.destination || "Destination"} variant="default" />
                            <div className={`flex max-sm:flex-col px-0 max-sm:items-start items-center justify-between mb-2 mt-4 py-2 text-start border-l-8 rounded-r-full xl:sticky top-[70px] z-20 bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[100%] xl:w-[100%] `} data-wow-delay="0.1s"
                            >
                                {/* Heading */}
                                <div className="px-2">
                                    <h1 className="playfair-display flex items-center font-extrabold mb-1 px-2 max-lg:text-[18px] text-2xl text-white">
                                        {pkg?.title || "Package Title"}
                                    </h1>
                                    <div className="flex items-center text-[10px] gap-1 px-2 mb-1 text-[#D4AF37]">
                                        {[...Array(pkg?.stars || 0)].map((_, i) => (
                                            <FaStar key={i} />
                                        ))}
                                    </div>
                                    {pkg?.route && (
                                        <h2 className="mt-0 hanuman-bold mb-0 px-2 max-lg:text-[12px] text-sm text-white">
                                            {pkg.route}
                                        </h2>
                                    )}
                                    {pkg?.duration && (
                                        <div className="max-lg:text-[12px] text-[16px] px-2 text-[#D4AF37] hanuman-bold">
                                            {pkg.duration}
                                        </div>
                                    )}
                                </div>
                                <div className="pr-8 pl-3 max-md:hidden md:visible lg:visible xl:visible 2xl:visible  gap-2">
                                    <h2 className="mt-0 pl-2 hanuman-bold  mb-1  max-xl:text-[14px] xl:text-[15px] text-white">
                                        Starting From <span className='text-[20px] text-[#D4AF37]'>
                                            ₹{pkg?.price ? Number(pkg.price).toLocaleString() : "N/A"}/-
                                        </span>{" "}
                                        <span className='text-[10px]'>
                                            Per Person
                                        </span>
                                    </h2>
                                    <div className='flex justify-end'>
                                        <div className="flex justify-center "> {/* Container alignment adjust karein */}
                                            <a
                                                href={`https://wa.me/919560070953?text=${encodeURIComponent(
                                                    `Hi, I’m interested in the ${pkg?.title || "this"} holiday package.
                                        Please share the best price, itinerary, and available options.`
                                                )}`} target="_blank"
                                                rel="noopener noreferrer"
                                                className="no-underline "
                                            >
                                                <button
                                                    type="submit"
                                                    className="
                                        relative z-10 overflow-hidden group flex items-center justify-center gap-2 
                                        rounded-full  shadow-xl isolation-auto transition-all duration-700
                                        
                                        /* Colors */
                                        bg-[#D4AF37] text-[#0B1C3D] hover:text-gray-50
                                        
                                        /* Responsive Sizing (Mobile first) */
                                        px-3 py-1 text-sm           /* Default: Mobile */
                                        sm:px-6 sm:py-1 sm:text-sm /* Tablets */
                                        lg:px-8 lg:py-1 lg:text-sm   /* Desktop */
                                        lg:font-semibold
                                        
                                        /* Hover Effect Logic */
                                        before:absolute before:w-full before:transition-all before:duration-700 
                                        before:-left-full before:hover:left-0 before:rounded-full before:bg-[#0B1C3D] 
                                        before:-z-10 before:aspect-square before:hover:scale-150
                                        "
                                                >
                                                    <span className="whitespace-nowrap">Get Quote</span>
                                                    <svg
                                                        className="
                                            shrink-0 ease-linear duration-300 rounded-full border border-[#D4AF37] p-2 rotate-45
                                            
                                            /* Responsive Icon Size */
                                            w-6 h-6   /* Mobile */
                                            sm:w-7 sm:h-7 /* Tablet/Desktop */
                                            
                                            /* Hover States */
                                            group-hover:rotate-90 group-hover:bg-gray-50 group-hover:border-none"
                                                        viewBox="0 0 16 19"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                                            className="fill-[#0B1C3D]"
                                                        ></path>
                                                    </svg>
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`max-md:visible md:hidden lg:hidden xl:hidden 2xl:hidden  fixed z-20 bottom-0 left-0 px-2 py-4  border-x-[9px] bg-[#0B1C3D]   border-[#D4AF37] wow fadeInUp w-[100%]  `} data-wow-delay="0.1s"
                                style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                            >
                                <div className=" flex items-center justify-between ">
                                    <h2 className="mt-0 hanuman-bold flex flex-col mb-0   max-sm:text-[10px]  text-white">
                                        Starting From
                                        <span className='text-[20px] text-[#D4AF37]'>
                                            ₹{pkg?.price ? Number(pkg.price).toLocaleString() : "N/A"}/-
                                        </span>
                                        <span className='text-[8px] text-white'>
                                            Per Person
                                        </span>
                                    </h2>
                                    <div className='flex gap-2'>
                                        <div className="flex justify-center "> {/* Container alignment adjust karein */}
                                            <a
                                                href={`https://wa.me/919560070953?text=${encodeURIComponent(
                                                    `Hi, I’m interested in the ${pkg?.title || "this"} holiday package.
                                                       Please share the best price, itinerary, and available options.`
                                                )}`} target="_blank"
                                                rel="noopener noreferrer"
                                                className="no-underline "
                                            >
                                                <button
                                                    type="submit"
                                                    className="
                                                                                            relative z-10 overflow-hidden group flex items-center justify-center gap-2 
                                                                                        rounded-full  shadow-xl isolation-auto transition-all duration-700
                                                                                        
                                                                                        /* Colors */
                                                                                        bg-[#D4AF37] text-[#0B1C3D] hover:text-gray-50
                                                                                        
                                                                                        /* Responsive Sizing (Mobile first) */
                                                                                        px-3 py-2 text-sm           /* Default: Mobile */
                                                                                        sm:px-6 sm:py-1 sm:text-sm /* Tablets */
                                                                                        lg:px-8 lg:py-1 lg:text-sm   /* Desktop */
                                                                                        lg:font-semibold
                                                                                        
                                                                                        /* Hover Effect Logic */
                                                                                        before:absolute before:w-full before:transition-all before:duration-700 
                                                                                        before:-left-full before:hover:left-0 before:rounded-full before:bg-[#0B1C3D] 
                                                                                        before:-z-10 before:aspect-square before:hover:scale-150
                                                                                        "
                                                >
                                                    <span className="whitespace-nowrap">Get Quote</span>
                                                    <svg
                                                        className="
                                                                                            shrink-0 ease-linear duration-300 rounded-full border border-[#0B1C3D] p-2 rotate-45
                                                                                            
                                                                                            /* Responsive Icon Size */
                                                                                            w-6 h-6   /* Mobile */
                                                                                            sm:w-7 sm:h-7 /* Tablet/Desktop */
                                                                                            
                                                                                            /* Hover States */
                                                                                            group-hover:rotate-90 group-hover:bg-gray-50 group-hover:border-none
                                                                                        "
                                                        viewBox="0 0 16 19"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                                            className="fill-[#0B1C3D]"
                                                        ></path>
                                                    </svg>
                                                </button>
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="lg:flex lg:px-[250px] gap-4 h-full relative w-full max-sm:px-0">
                                <Swiper
                                    modules={[Pagination, Autoplay]}
                                    spaceBetween={15}
                                    loop={true}
                                    // navigation={true}
                                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                                    // pagination={{ clickable: true }}
                                    className="relative max-lg:w-full w-[100%] h-[60vh] max-xs:h-[30vh] cursor-pointer rounded-lg"
                                >
                                    {Array.isArray(pkg?.images) && pkg.images.length > 0 ? (
                                        pkg.images.map((img, index) => (
                                            <SwiperSlide key={index}>
                                                <div className="relative h-full">
                                                    <img
                                                        src={img || deafultImage}
                                                        alt={pkg?.title || "package"}
                                                        loading="lazy"
                                                        className="w-full h-full object-cover rounded-xl"
                                                    />

                                                    <span className="absolute top-3 left-0 bg-[#0B1C3D] text-white max-md:text-[11px] md:text-[14px] lg:text-sm xl:text-sm px-3 border-l-8 border-[#D4AF37] py-1 rounded-r-xl">
                                                        <span>{pkg?.tags || "Top"}</span>
                                                        <span> ⭐ {pkg?.rating || "4.5"} Rated</span>
                                                    </span>
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    ) : (
                                        <SwiperSlide>
                                            <img
                                                src={deafultImage}
                                                alt="fallback"
                                                className="w-full h-full object-cover rounded-xl"
                                            />
                                        </SwiperSlide>
                                    )}
                                </Swiper>
                                <div className="w-full mt-4 rounded-lg">
                                    {pkg?.overview && pkg.overview.trim() !== "" && (
                                        <div className="max-lg:w-full  w-[100%] rounded-lg">
                                            <div className="text-md text-white">
                                                <div className="w-full bg-[#0B1C3D] text-white px-1 rounded-lg">

                                                    {/* Heading */}
                                                    <div
                                                        className="flex items-center justify-between mb-4 text-start border-l-8 rounded-r-full  bg-[#0B1C3D]   border-[#D4AF37]"
                                                    >
                                                        <h1 className="playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white ">
                                                            Package Overview
                                                        </h1>
                                                    </div>

                                                    {/* Content */}
                                                    <p className="poppins lg:text-[12px] xl:text-sm leading-relaxed">
                                                        {pkg.overview}
                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="lg:px-[250px]  w-full mt-4 rounded-lg">
                                <div className='lg:flex'>
                                    <div className="text-md w-full  text-white">
                                        <div className="w-full bg-[#0B1C3D] text-white px-1 rounded-lg">
                                            {/* Heading */}
                                            <div
                                                className="flex items-center justify-between mb-4 text-start border-l-8 rounded-r-full  bg-[#0B1C3D] max-md:w-full w-[25%] border-[#83d437]"
                                            >
                                                <h1 className="playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white ">
                                                    Availability
                                                </h1>
                                            </div>
                                            {pkg?.availableDate && (
                                                <div className="mb-2 cursor-pointer text-white hanuman-bold">
                                                    <div className="flex flex-wrap gap-1 px-1 mt-1 text-[#ffffff]">
                                                        {pkg.availableDate.map((date, index) => (
                                                            <div key={index} className="bg-white/20 hover:bg-transparent px-1.5 py-0.5 rounded">
                                                                {date}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="text-md w-full max-md:mt-3 text-white">
                                        <div className="w-full bg-[#0B1C3D] text-white rounded-lg">
                                            {/* Heading */}
                                            <div
                                                className="flex items-center justify-between mb-4 text-start border-l-8 rounded-r-full  bg-[#0B1C3D] max-md:w-full w-full border-[#048012]"
                                            >
                                                <h1 className="playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white ">
                                                    Ex Departure Cities
                                                </h1>
                                            </div>
                                            {pkg?.departureCity && (
                                                <div className="mb-2 cursor-pointer text-white hanuman-bold">
                                                    <div className="flex flex-wrap gap-1 px-1 mt-1 text-[#ffffff]">
                                                        {pkg.departureCity.map((date, index) => (
                                                            <div key={index} className="bg-white/20 hover:bg-transparent px-2 py-0.5 rounded">
                                                                {date}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='max-lg:w-full w-full  bg-[#0B1C3D]   rounded-lg mt-4'
                                >
                                    <div className=" text-md  text-white">
                                        <div className={`flex items-center justify-between mt-1 mx-1 mb-1 text-start border-l-8 rounded-r-full max-md:w-full   bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp  `} data-wow-delay="0.1s"
                                        >
                                            {/* Heading */}
                                            <div className="">
                                                <h1 className=" playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white">
                                                    Package Includes
                                                </h1>
                                            </div>
                                        </div>

                                        <div className="w-full   bg-[#0B1C3D] text-[#0B1C3D]  max-lg:px-2 lg:px-0 xl:px-2 py-4 rounded-lg">
                                            {/* TOP TABS */}
                                            <div className="flex flex-wrap max-lg:gap-[8.7px] lg:gap-1.4 xl:gap-[34px] ">
                                                {filteredTabs.map((tab) => (
                                                    <div
                                                        key={tab?.id}
                                                        onClick={() => setActive(tab?.id)}
                                                        className={`flex flex-col items-center p-2 rounded-t-full gap-1 cursor-pointer transition-all duration-300 
                                                        ${active === tab?.id ? "bg-[#D4AF37]" : "text-gray-300 hover:bg-[#D4AF37]"}`}
                                                    >
                                                        <div className="max-md:text-xl text-xl">{tab?.icon}</div>

                                                        <span className="max-md:text-xs text-sm poppins">
                                                            {tab?.label}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* CONTENT PANEL */}
                                            <div className="text-white py-0 rounded-lg transition-all duration-500 ease-in-out">

                                                {/* FLIGHTS */}
                                                {active === "flights" && (
                                                    <div className="space-y-5 rounded-tl-none rounded-xl bg-[#D4AF37] py-1">
                                                        {Array.isArray(pkg?.flights) && pkg.flights.length > 0 ? (
                                                            pkg.flights.map((f, i) => (
                                                                <div key={i} className="bg-white/30 text-[#0B1C3D] p-3 mx-2 my-3 rounded-md flex justify-between">
                                                                    <span>{f?.from || "N/A"} → {f?.to || ""}</span>
                                                                    <span>{f?.type || ""}</span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-3 text-sm text-[#0B1C3D]">No flight details</div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* HOTELS */}
                                                {active === "hotels" && (
                                                    <div className="space-y-5 rounded-tl-none rounded-xl bg-[#D4AF37] py-1">
                                                        {Array.isArray(pkg?.hotels) && pkg.hotels.length > 0 ? (
                                                            pkg.hotels.map((hot, i) => (
                                                                <div key={i} className="bg-white/30 text-[#0B1C3D] p-3 mx-2 my-3 rounded-md">
                                                                    {hot?.location || "Location"} - {hot?.nights || ""} ({hot?.type || ""})
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-3 text-sm text-[#0B1C3D]">No hotel details</div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* SIGHTSEEING */}
                                                {active === "sightseeing" && (
                                                    <div className="space-y-5 rounded-xl bg-[#D4AF37] py-1">
                                                        {Array.isArray(pkg?.sightseeing) && pkg.sightseeing.length > 0 ? (
                                                            pkg.sightseeing.map((s, i) => (
                                                                <div key={i} className="bg-white/30 text-[#0B1C3D] p-3 mx-2 my-3 rounded-md">
                                                                    {s?.title || "Sightseeing"}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-3 text-sm text-[#0B1C3D]">No sightseeing</div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* TRANSFERS */}
                                                {active === "transfers" && (
                                                    <div className="space-y-5 rounded-xl bg-[#D4AF37] py-1">
                                                        {Array.isArray(pkg?.transfers) && pkg.transfers.length > 0 ? (
                                                            pkg.transfers.map((t, i) => (
                                                                <div key={i} className="bg-white/30 text-[#0B1C3D] p-3 mx-2 my-3 rounded-md flex justify-between">
                                                                    <span>{t?.from || "N/A"} → {t?.to || ""}</span>
                                                                    <span>{t?.type || ""}</span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-3 text-sm text-[#0B1C3D]">No transfer details</div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* MEALS */}
                                                {active === "meals" && (
                                                    <div className="space-y-5 rounded-xl bg-[#D4AF37] py-1">
                                                        {Array.isArray(pkg?.meals) && pkg.meals.length > 0 ? (
                                                            pkg.meals.map((m, i) => (
                                                                <div key={i} className="bg-white/30 text-[#0B1C3D] p-3 mx-2 my-3 rounded-md">
                                                                    {m?.title || "Meal"}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-3 text-sm text-[#0B1C3D]">No meals</div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* VISA */}
                                                {active === "visa" && (
                                                    <div className="space-y-5 rounded-tr-none rounded-xl bg-[#D4AF37] py-1">
                                                        {Array.isArray(pkg?.visa) && pkg.visa.length > 0 ? (
                                                            pkg.visa.map((v, i) => (
                                                                <div key={i} className="bg-white/30 text-[#0B1C3D] p-3 mx-2 my-3 rounded-tr-none rounded-md">
                                                                    {v?.title || "Visa"}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-3 text-sm text-[#0B1C3D]">No visa info</div>
                                                        )}
                                                    </div>
                                                )}
                                                {/* Crusie */}
                                                {active === "cruise" && (
                                                    <div className="space-y-5 rounded-tr-none rounded-xl bg-[#D4AF37] py-1">
                                                        {Array.isArray(pkg?.cruise) && pkg.cruise.length > 0 ? (
                                                            pkg.cruise.map((v, i) => (
                                                                <div key={i} className="bg-white/30 text-[#0B1C3D] p-3 mx-2 my-3 rounded-tr-none rounded-md">
                                                                    {v?.title || "cruise"}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-3 text-sm text-[#0B1C3D]">No Crusie info</div>
                                                        )}
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='max-lg:w-full xl:px-[250px] w-full py-3  rounded-lg gap-4'>
                                {Array.isArray(pkg?.itinerary) && pkg.itinerary.length > 0 && (
                                    <div className="w-full rounded-lg text-md lg:mt-5  xl:mt-5 text-white bg-[#0B1C3D] "
                                    >
                                        <div className={`flex items-center w-full justify-between mt-1 mx-1 mb-2 text-start border-l-8 rounded-r-full  bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp  `} data-wow-delay="0.1s"
                                        >
                                            {/* Heading */}
                                            <div className="">
                                                <h1 className=" playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white ">
                                                    Itinerary
                                                </h1>
                                            </div>
                                            <div className="hanuman-bold text-[14px] cursor-pointer px-2 py- mr-2 hover:text-white  hover:underline underline-offset-4  rounded-lg text-[#D4AF37] " onClick={toggleAll}>
                                                {activeIndexes.length === pkg.itinerary.length ? "Collapse All" : "Expand All"}
                                            </div>
                                        </div>

                                        <div className="relative pl-4 ">
                                            {/* Vertical Line */}
                                            <div className="absolute left-2 z-10 top-0 h-full w-[1px] bg-gray-300/20"></div>

                                            {pkg?.itinerary?.map((day, index) => (
                                                <div key={index} className="relative mb-4">

                                                    <FontAwesomeIcon
                                                        onClick={() => toggleAccordion(index)}
                                                        icon={faDiamond}
                                                        className={`absolute -left-4 top-3 w-4 h-4 ${activeIndexes.includes(index) ? "text-[#D4AF37]" : "text-[#ffffff]"
                                                            }`}
                                                    />

                                                    <button
                                                        onClick={() => toggleAccordion(index)}
                                                        className="w-full flex justify-between items-center text-left py-2 px-2"
                                                    >
                                                        <span className="font-semibold lg:text-[12px] xl:text-[15px] poppins">
                                                            Day {day?.day || index + 1} : {day?.title || "Itinerary"}
                                                        </span>

                                                        <span className={`transition-transform ${activeIndexes.includes(index) ? "rotate-180" : ""}`}>
                                                            <FaAngleDown />
                                                        </span>
                                                    </button>

                                                    <div className={`${activeIndexes.includes(index) ? "max-h-[300px]" : "max-h-0"} overflow-hidden`}>
                                                        <div className="py-1 px-4 lg:text-[12px] xl:text-[14px] poppins">
                                                            {day?.detail || "N/A"}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                <div className="bg-[#0B1C3D] rounded-lg px-1 w-full lg:mt-5  xl:mt-5"
                                >
                                    <div className="grid md:grid-cols-2 gap-6 ">
                                        {/* INCLUSIONS */}
                                        {Array.isArray(pkg?.inclusions) && pkg.inclusions.length > 0 && (
                                            <div>
                                                <div
                                                    className="flex items-center justify-between mt-1 mb-1  text-start border-l-8 rounded-r-full w-[50%] bg-[#0B1C3D] border-[#048012]"
                                                >
                                                    <div>
                                                        <h1 className="playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white">
                                                            Inclusions
                                                        </h1>
                                                    </div>
                                                </div>

                                                <ul className="space-y-2 mt-4 pl-0 poppins">
                                                    {pkg.inclusions.map((item, index) => (
                                                        <li key={index} className="flex items-start gap-3">
                                                            <span className="text-green-600 text-lg">
                                                                <FontAwesomeIcon icon={faCheck} />
                                                            </span>
                                                            <span className="text-white lg:text-[12px] xl:text-sm">
                                                                {item || "Included"}
                                                            </span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        {/* EXCLUSIONS */}
                                        {Array.isArray(pkg?.exclusions) && pkg.exclusions.length > 0 && (
                                            <div>
                                                <div className={`flex items-center justify-between mt-1 mb-1  text-start border-l-8 rounded-r-full w-[50%] bg-[#0B1C3D]  border-[#b90606] wow fadeInUp  `} data-wow-delay="0.1s"
                                                >
                                                    {/* Heading */}
                                                    <div className="">
                                                        <h1 className=" playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white ">
                                                            Exclusions
                                                        </h1>
                                                        {/* <h2 className="max-sm:text-[10px] xl:text-[15px] px-2 text-start poppins text-[#ffffff] mb-1 ">From <span className='font-bold'>₹29,000/- </span><span className="text-[0.8rem]">Per Person</span></h2> */}
                                                    </div>
                                                </div>

                                                <ul className="space-y-2 mt-4 pl-0 poppins">
                                                    {pkg?.exclusions?.map((item, index) => (
                                                        <li key={index} className="flex items-start gap-3">
                                                            <span className="text-red-500 text-lg"><FontAwesomeIcon icon={faXmark} /></span>
                                                            <span className="text-white lg:text-[12px] xl:text-sm">{item || "Excluded"}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                            <div className="max-lg:w-full xl:px-[250px] w-full rounded-lg mt-4">
                                <div className="text-md text-white">
                                    <div className="w-full bg-[#0B1C3D] text-white px-1 rounded-lg">

                                        {/* Heading */}
                                        <div className="flex items-center justify-between mb-4 text-start border-l-8 rounded-r-full bg-[#0B1C3D] border-[#D4AF37]">
                                            <h2 className="playfair-display font-extrabold mb-0 py-1 px-2 max-lg:text-xl text-2xl text-white">
                                                Important Notes
                                            </h2>
                                        </div>

                                        {/* Content */}
                                        <div className="poppins lg:text-[12px] xl:text-sm sm:text-base leading-relaxed pb-3">
                                            <ul className="pl-0 space-y-3 text-white poppins lg:text-[12px] xl:text-sm sm:text-base leading-relaxed">

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold ">●</span>
                                                    <span>
                                                        The itinerary shared on this page is for reference purposes only. The final day-wise itinerary will be provided at the time of booking confirmation and may vary depending on hotel availability, operational requirements, weather conditions, and local regulations.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Package prices are dynamic and may increase or decrease based on travel dates, seasonality, hotel availability, flight/train fares, and destination demand at the time of booking.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Rates mentioned are indicative and subject to availability. Final pricing will be confirmed before booking.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Sightseeing schedules may be adjusted due to weather conditions, road closures, government restrictions, local events, or operational reasons.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Accommodation check-in and check-out timings are subject to the policies of the respective hotels, camps, houseboats, resorts, or other accommodation providers.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Early check-in, late check-out, room upgrades, and special requests are subject to availability and may incur additional charges.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Guests are advised to carry valid government-issued photo identification during travel.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Certain activities, entry tickets, permits, adventure sports, personal expenses, and meals not specifically mentioned in the inclusions may be chargeable extra.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Travelers are responsible for ensuring they possess all required travel documents, permits, visas, and identification before departure.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Shri Radhe Holidays reserves the right to modify the itinerary, hotel selection, transportation arrangements, or sightseeing sequence when necessary to ensure smooth operations.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Any unused services included in the package are non-refundable.
                                                    </span>
                                                </li>

                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        For the best experience, we recommend confirming your booking well in advance, especially during peak seasons, long weekends, festive periods, and school holidays.
                                                    </span>
                                                </li>
                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Group tour departures operate on fixed schedules. Participants are requested to adhere to reporting times and tour schedules to ensure smooth operations for the entire group.
                                                    </span>
                                                </li>
                                                <li className="flex items-start gap-2">
                                                    <span className="text-[#D4AF37] font-bold">●</span>
                                                    <span>
                                                        Seat allocation in vehicles, coaches, trains, flights, or other modes of transport is subject to availability and operator policies.
                                                    </span>
                                                </li>

                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
                : (
                    <div className=" px-4 text-center flex items-center justify-center  flex-col py-10 text-gray-600 poppins" id="details">
                        <p className="text-lg font-semibold mb-2">
                            Packages for {pkg?.title ? pkg?.title : "this destination"} are not currently listed on our website.
                        </p>
                        <p className="text-sm mb-4">
                            Contact us to get the best available deals, customized itineraries, and latest pricing.
                        </p>

                        <div className="flex justify-start mr-1 mb-1"> {/* Container alignment adjust karein */}
                            <a
                                href={`https://wa.me/919560070953?text=${encodeURIComponent(
                                    `Hi, I’m interested in  ${pkg?.title ? " the " + pkg?.title : "this destination"} holiday package.
                              Please share the best price, itinerary, and available options.`
                                )}`} target="_blank"
                                rel="noopener noreferrer"
                                className="no-underline "
                            >
                                <button
                                    type="submit"
                                    className="
                              relative z-10 overflow-hidden group flex items-center justify-center gap-2 
                            rounded-full  shadow-xl isolation-auto transition-all duration-700
                            
                            /* Colors */
                            bg-[#0B1C3D] text-[#D4AF37] hover:text-gray-50
                            
                            /* Responsive Sizing (Mobile first) */
                            px-3 py-2 text-sm           /* Default: Mobile */
                            sm:px-6 sm:py-3 sm:text-sm /* Tablets */
                            lg:px-8 lg:py-3 lg:text-sm   /* Desktop */
                            lg:font-semibold
                            
                            /* Hover Effect Logic */
                            before:absolute before:w-full before:transition-all before:duration-700 
                            before:-left-full before:hover:left-0 before:rounded-full before:bg-[#D4AF37] 
                            before:-z-10 before:aspect-square before:hover:scale-150
                          "
                                >
                                    <span className="whitespace-nowrap">Get My Quote</span>
                                    <svg
                                        className="
                                shrink-0 ease-linear duration-300 rounded-full border border-[#D4AF37] p-2 rotate-45
                                
                                /* Responsive Icon Size */
                                  w-6 h-6   /* Mobile */
                                sm:w-7 sm:h-7 /* Tablet/Desktop */
                                
                                /* Hover States */
                                group-hover:rotate-90 group-hover:bg-gray-50 group-hover:border-none
                              "
                                        viewBox="0 0 16 19"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                            className="fill-[#D4AF37]"
                                        ></path>
                                    </svg>
                                </button>
                            </a>
                        </div>
                        
                    </div>
                )
            }
        </>
    )
}

export default GroupTourPackagesDetails
